import { useTranslation } from 'react-i18next';
import Price, { PriceModuleProps } from '@ingka/price-module';
import ConditionalRender from '../../components/ConditionalRender';
import { CSSEvent } from '../../types/model';
import { formatEventPrice, isEventFree } from '../../utils/formatPrice';
import { EventPriceAmount, EventPriceNote } from './style';
import { config } from '../../config';
import styled from 'styled-components';
import { useEffect } from 'react';

type PropsType = {
  event: CSSEvent;
};

const StyledDiv = styled.div`
  margin-bottom: 10px;
`;

const EventPrice = ({ event }: PropsType) => {
  const { t } = useTranslation();
  const isFree = isEventFree(event.price);
  const amount = event?.price?.amount || 0;
  let dualCurrencyProps = {};

  if (!isFree && amount) {
    dualCurrencyProps = {
      currentPriceProps: {
        currencyLabel: config.currency,
        integerValue: `${amount || 0}`,
        caption: '',
        priceOfferType: 'regular',
        currencyPosition: 'trailing',
        size: 'large',
      },
      secondaryCurrencyPriceProps: {
        className: 'dualPrice-second-price',
        currencyLabel: config.dualCurrencyInfo.currency,
        integerValue: `${(
          (amount || 0) * config.dualCurrencyInfo?.conversionFactor
        ).toFixed(2)}`,
        caption: '',
        currencyPosition: 'trailing',
        size: 'small',
      },
      productName: '',
    };
  }

  const formattedPrice = formatEventPrice(event.price, t);
  const firstChar = formattedPrice.charAt(0);
  const restOfPrice = formattedPrice.slice(1);

  useEffect(() => {
    if (!document.getElementById('won-symbol-style')) {
      const style = document.createElement('style');
      style.id = 'won-symbol-style';
      style.innerHTML = `
        .won-symbol {
          font-weight: bold;
          font-size: 0.5em; /* Adjust font size for alignment */
          position: relative;
          top: -8px; /* Adjust vertical alignment */
          margin-right: 3px;
          transform: scaleX(1.5); /* Stretch horizontally */
          display: inline-block; /* Required for transform to work properly */
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <>
      <ConditionalRender predicate={!config.dualCurrencyInfo.enable}>
      <EventPriceAmount isFree={isFree}>
          <b>
            {firstChar === '₩' ? (
              <>
                <span className="won-symbol">{firstChar}</span>
                {restOfPrice}
              </>
            ) : (
              formattedPrice
            )}
          </b>
        </EventPriceAmount>
        <ConditionalRender predicate={!isFree}>
          <EventPriceNote>{t('event.cost')}</EventPriceNote>
        </ConditionalRender>
      </ConditionalRender>
      <ConditionalRender predicate={config.dualCurrencyInfo.enable && !isFree}>
        <StyledDiv>
          <Price {...(dualCurrencyProps as unknown as PriceModuleProps)} />
        </StyledDiv>
      </ConditionalRender>
    </>
  );
};

export default EventPrice;
